<!-- 自定义列设置弹窗 -->
<template>
    <div v-loading="loading">
        <div class="set-content">
            <div v-for="item in columnData" :key="item.ColumnCode" class="set-item">
                <el-checkbox :disabled="!item.IsCanSet" :checked="item.IsShow" v-model="item.IsShow" border class="item-canset"></el-checkbox>
                <el-input v-model="item.ColumnName" disabled class="item-cname"></el-input>
            </div>
        </div>
        <div slot="footer" class="dialog-footer" style="text-align: right; margin-top: 10px; padding-bottom: 10px">
            <el-button class="search-btn btn-primary" size="small" @click="submit">保存设置</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['staffId', 'tableCode'],
    components: {},
    data() {
        return {
            columnData: [],
            loading: false
        };
    },
    mounted() {
        this.getSetsData();
    },
    methods: {
        getSetsData() {
            let that = this;
            this.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetEntpTableColumnList',
                    data: {
                        staffId: that.staffId,
                        tableCode: that.tableCode
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (data) that.columnData = data;
                })
                .catch(() => {})
                .finally(() => {
                    that.loading = false;
                });
        },
        submit() {
            this.loading = true;
            this.$util
                .axiosPost({
                    url: '/api/EntpInfoManagement/SubmitTableSetsForStaff',
                    data: { StaffId: this.staffId, TableCode: this.tableCode, ColumnData: this.columnData },
                    hideLoading: true
                })
                .then(res => {
                    this.$util.successMsg(res.errmsg);
                    this.closeDialog(true);
                })
                .catch(() => {})
                .finally(() => {
                    this.loading = false;
                });
        },
        closeDialog(isEdit) {
            this.$emit('closeDialog', isEdit);
        }
    }
};
</script>
<style lang="less" scoped>
.set-content {
    display: flex;
    flex-direction: column;
    margin-top:10px;

    .set-item {
        display: flex;
        flex-direction: row;

        .item-canset {
            width: 10%;
            border-radius: 5px 0 0 5px;
        }

        .item-cname {
            width: 90%;
            border-radius: 0 5px 5px 0;
        }

    }
    .el-input-group__prepend {
        padding: 0 10px;
        border-radius: 0;
    }
    .el-input-group__append {
        padding: 0 10px;
    }
    .el-input__inner {
        border-radius: 0;
    }
}
</style>
